export default __webpack_public_path__ + "static/media/approved.7d90b88a.svg";